import {
  buildProps,
  isArray,
  isBoolean,
  isNumber,
  isObject,
  isString,
} from '@jdesign-vue/utils'
import { UPDATE_MODEL_EVENT } from '@jdesign-vue/constants'

import type { ExtractPropTypes, PropType } from 'vue'
import type StatisticGroup from './statistic-group.vue'

type StatisticValueType = string | number | boolean

export const statisticGroupEmits = {
  [UPDATE_MODEL_EVENT]: (val: StatisticValueType[] | StatisticValueType) =>
    isArray(val) ||
    isNumber(val) ||
    isString(val) ||
    isBoolean(val) ||
    isObject(val),
  change: (val: StatisticValueType[] | StatisticValueType) =>
    isArray(val) ||
    isNumber(val) ||
    isString(val) ||
    isBoolean(val) ||
    isObject(val),
}

export const statisticGroupProps = buildProps({
  modelValue: {
    type: [Array as PropType<Array<string | number>>, String, Number, Boolean],
    default: () => [],
  },
  disabled: {
    type: Boolean,
  },
  size: {
    type: String,
    values: ['', 'small'],
  },
  type: {
    type: String,
    values: ['', 'radio', 'checkbox'],
    default: '',
  },
  combine: {
    type: Boolean,
  },
} as const)
export type StatisticGroupProps = ExtractPropTypes<typeof statisticGroupProps>

export type StatisticGroupInstance = InstanceType<typeof StatisticGroup>
